import React from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./LanguageContext";
import { AuthProvider } from "./AuthContext";
import Home from "./Home";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import SegmentPage from "./pages/SegmentPage";
import PolicyPage from "./pages/PolicyPage";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth return synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/produkt/:id" element={<SegmentPage />} />
      <Route path="/policy/:type" element={<PolicyPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-paper min-h-screen">
      <HelmetProvider>
        <LanguageProvider>
          <AuthProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </AuthProvider>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
